document.addEventListener("DOMContentLoaded", function () {
	// Get the main contact form
	const form = document.querySelector(".js-contact-form");
	if (!form) return;
	const errorMsgs = FoxTheme.contactStrings;

	// Get all shadow form IDs from data attributes
	const defaultShadowFormId = form.getAttribute("data-shadow-form-id");
	const customMadeShadowFormId = form.getAttribute("data-custom-made-shadow-form-id");
	const professionalDemandShadowFormId = form.getAttribute("data-professional-demand-shadow-form-id");
	const restorationShadowFormId = form.getAttribute("data-restoration-shadow-form-id");

	// Function to get the correct shadow form ID based on subject
	function getShadowFormId() {
		const subjectSelect = form.querySelector("#ContactForm-objet");
		if (!subjectSelect) return defaultShadowFormId;

		const subject = subjectSelect.value;

		switch (subject) {
			case "custom_request":
				return customMadeShadowFormId || defaultShadowFormId;
			case "professional":
				return professionalDemandShadowFormId || defaultShadowFormId;
			case "repair":
				return restorationShadowFormId || defaultShadowFormId;
			default:
				return defaultShadowFormId;
		}
	}

	/**
	 * Returns the embedded form element (generated by Shopify App 'Shopify Forms').
	 *
	 * Shopify Forms historically used a custom `<form-embed>` tag, but starting in January 2026,
	 * Shopify introduced a new `<shopify-form-embed>` component.
	 * This helper abstracts that change so callers don't worry about which tag is actually in DOM.
	 *
	 * @param shpFormRootContainer The root container of the Shopify Form
	 * @returns {HTMLElement | null} The first matching form‑embed element, or `null` if none are found.
	 */
	function getFormEmbed(shpFormRootContainer) {
		// legacy element
		const formEmbed = shpFormRootContainer.querySelector("form-embed");
		// new element as of january 2026
		return formEmbed ?? shpFormRootContainer.querySelector("shopify-forms-embed");
	}

	// Utility to create and show an error message span for a field or label
	function createErrorSpan(target, msg, className = "js-error-msg") {
		// Remove previous error
		let errorSpan = target.parentNode.querySelector("." + className);
		if (errorSpan) errorSpan.remove();
		const err = document.createElement("span");
		err.className = "form-message form-message--error " + className;
		err.style.color = "#E8083E";
		err.style.display = "block";
		err.style.marginTop = "0.2em";
		err.textContent = msg;
		// If target is a .select div, insert after it; else, append to parent
		if (target.classList && target.classList.contains("select")) {
			target.parentNode.insertBefore(err, target.nextSibling);
		} else {
			target.parentNode.appendChild(err);
		}
		return err;
	}

	// Dynamically handle file name display for all file inputs, with validation for max files and type
	function setupFileInputDisplay(inputId, labelId) {
		const inputEl = document.getElementById(inputId);
		const labelEl = document.getElementById(labelId);
		if (inputEl && labelEl) {
			inputEl.addEventListener("change", () => {
				// Remove previous error
				let errorSpan = labelEl.parentNode.querySelector(".js-file-error");
				if (errorSpan) errorSpan.remove();

				const files = Array.from(inputEl.files);
				// Validate file count
				if (files.length > 3) {
					inputEl.value = "";
					labelEl.textContent = errorMsgs.attachments;
					createErrorSpan(labelEl, errorMsgs.fileInputError, "js-file-error");
					return;
				}
				// Validate file types (images only)
				const invalidFile = files.find((f) => !/^image\/(jpeg|png)$/.test(f.type));
				if (invalidFile) {
					inputEl.value = "";
					labelEl.textContent = errorMsgs.attachments;
					createErrorSpan(labelEl, errorMsgs.fileInputTypeError, "js-file-error");
					return;
				}
				// Display file names
				if (files.length > 0) {
					labelEl.textContent = files.map((file) => file.name).join(", ");
				} else {
					labelEl.textContent = errorMsgs.attachments;
				}
			});
		}
	}
	setupFileInputDisplay("file-upload", "file-name");
	setupFileInputDisplay("custom-request-file-upload", "custom-request-file-name");

	// Ajout : auto-formatage du champ purchase_date (jj/mm/aaaa)
	const purchaseDateInput = document.querySelector('[name="contact[purchase_date]"]');
	if (purchaseDateInput) {
		purchaseDateInput.addEventListener("input", function (e) {
			let value = purchaseDateInput.value.replace(/\D/g, ""); // Retirer tout sauf chiffres
			if (value.length > 8) value = value.slice(0, 8);
			let formatted = "";
			if (value.length > 4) {
				formatted = value.slice(0, 2) + "/" + value.slice(2, 4) + "/" + value.slice(4);
			} else if (value.length > 2) {
				formatted = value.slice(0, 2) + "/" + value.slice(2);
			} else {
				formatted = value;
			}
			purchaseDateInput.value = formatted;
		});
	}

	// Main fields for validation
	const mainFields = {
		firstName: form.querySelector('[name="contact[first_name]"]'),
		lastName: form.querySelector('[name="contact[last_name]"]'),
		email: form.querySelector('[name="contact[email]"]'),
		confirmEmail: form.querySelector('[name="confirm_email"]'),
		subject: form.querySelector('[name="contact[subject]"]'),
		message: form.querySelector('[name="contact[body]"]'),
		purchasePlace: form.querySelector('[name="contact[purchase_place]"]'),
	};

	const residenceCountrySelect = form.querySelector('[name="contact[residence_country]"]');
	const messageWrapper = form.querySelector("#ContactForm-message-wrapper");
	const retourWrapper = form.querySelector("#ContactForm-retour-wrapper");
	const repairWrapper = form.querySelector("#ContactForm-repair-wrapper");
	const orderTrackingWrapper = form.querySelector("#ContactForm-order-tracking-wrapper");
	const withdrawWrapper = form.querySelector("#ContactForm-withdraw-wrapper");
	const customRequestWrapper = form.querySelector("#ContactForm-custom-request-wrapper");
	const customRequestTextarea = form.querySelector('[name="contact[custom_request_message]"]');

	const withdrawAdditionalMessage = form.querySelector("#ContactForm-withdraw-additional-message");

	// Check if a field is visible and enabled (not hidden or disabled)
	function isFieldActive(field) {
		return field && field.offsetParent !== null && !field.disabled;
	}

	// Show error message for a field (creates span if needed)
	function showError(field, msg) {
		removeError(field);
		if (field.type === "select-one") {
			// Special case for subject select (ContactForm-objet)
			if (field.name === "contact[subject]") {
				// Place error after .select div
				let selectDiv = field.closest(".select");
				let errSpan = selectDiv?.parentNode.querySelector(".js-error-msg-subject");
				if (!errSpan) {
					errSpan = createErrorSpan(selectDiv, msg, "js-error-msg-subject");
				}
				errSpan.innerText = msg;
				errSpan.style.display = "block";
			}
			// Special case for residence_country select
			else if (field.name === "contact[residence_country]") {
				let selectDiv = field.closest(".select");
				let span = selectDiv?.parentNode.querySelector(".js-error-msg-country");
				if (!span) {
					span = createErrorSpan(selectDiv, msg, "js-error-msg-country");
				}
				span.innerText = msg;
				span.style.display = "block";
				field.setAttribute("aria-invalid", "true");
			}
			// Default for other selects
			else {
				let selectDiv = field.closest(".select");
				let span = selectDiv?.parentNode.querySelector(".js-error-msg");
				if (!span) {
					span = createErrorSpan(selectDiv, msg, "js-error-msg");
				}
				span.innerText = msg;
				span.style.display = "block";
				field.setAttribute("aria-invalid", "true");
			}
		} else {
			let span = field.parentNode.querySelector(".js-error-msg");
			if (!span) {
				span = createErrorSpan(field, msg, "js-error-msg");
			}
			span.innerText = msg;
			span.style.display = "block";
			field.setAttribute("aria-invalid", "true");
		}
	}

	// Remove error message for a field
	function removeError(field) {
		field.removeAttribute("aria-invalid");
		if (field.type === "select-one") {
			if (field.name === "contact[subject]") {
				let selectDiv = field.closest(".select");
				const errSpan = selectDiv?.parentNode.querySelector(".js-error-msg-subject");
				if (errSpan) {
					errSpan.innerText = "";
					errSpan.style.display = "none";
				}
			} else if (field.name === "contact[residence_country]") {
				let selectDiv = field.closest(".select");
				const err = selectDiv?.parentNode.querySelector(".js-error-msg-country");
				if (err) err.remove();
			} else {
				let selectDiv = field.closest(".select");
				const err = selectDiv?.parentNode.querySelector(".js-error-msg");
				if (err) err.remove();
			}
		} else {
			const err = field.parentNode.querySelector(".js-error-msg");
			if (err) err.remove();
		}
	}

	// Validate a single field (required, visible, enabled)
	function validateField(field) {
		// Only validate if required and active
		if (!field.required || !isFieldActive(field)) {
			removeError(field);
			return true;
		}
		// Email format validation
		if ((field === mainFields.email || field === mainFields.confirmEmail) && field.value.trim()) {
			// Regex: at least one char before @, at least one after @, a dot, at least one after dot
			const emailPattern = /^[^@]+@[^@]+\.[^@]+$/;
			if (!emailPattern.test(field.value.trim())) {
				showError(field, errorMsgs.emailFormat || "Format d'email invalide");
				return false;
			}
		}
		// Special handling for select fields
		if (field.tagName === "SELECT") {
			if (!field.value || field.options[field.selectedIndex].disabled) {
				if (field.name === "contact[return_reason]") {
					showError(field, errorMsgs.returnReason);
				} else if (field === mainFields.purchasePlace) {
					showError(field, errorMsgs.purchaseLocation);
				} else if (field === mainFields.subject) {
					showError(field, errorMsgs.objet);
				} else if (field === residenceCountrySelect) {
					showError(field, errorMsgs.country);
				} else {
					showError(field, errorMsgs.default || errorMsgs.demande);
				}
				return false;
			}
		}
		// Required text/textarea fields
		if (!field.value.trim()) {
			switch (field) {
				case mainFields.firstName:
					showError(field, errorMsgs.firstName);
					break;
				case mainFields.lastName:
					showError(field, errorMsgs.lastName);
					break;
				case mainFields.email:
					showError(field, errorMsgs.email);
					break;
				case mainFields.confirmEmail:
					showError(field, errorMsgs.confirmEmail);
					break;
				case mainFields.subject:
					showError(field, errorMsgs.objet);
					break;
				case mainFields.message:
					showError(field, errorMsgs.message);
					break;
				case mainFields.purchasePlace:
					showError(field, errorMsgs.purchaseLocation);
					break;
				default:
					// Custom request textarea validation
					if (field === customRequestTextarea) {
						showError(field, errorMsgs.message);
						break;
					}
					// Map by input name for all required fields
					switch (field.name) {
						case "contact[order_tracking_number]":
						case "contact[order_number]":
							showError(field, errorMsgs.orderNumber);
							break;
						case "contact[product_refs]":
							showError(field, errorMsgs.orderRef);
							break;
						case "contact[return_reason]":
							showError(field, errorMsgs.returnReason);
							break;
						case "contact[residence_country]":
							showError(field, errorMsgs.country);
							break;
						case "contact[product_ref_repair]":
							showError(field, errorMsgs.productRef);
							break;
						case "contact[repair_message]":
							showError(field, errorMsgs.message);
							break;
						case "contact[purchase_place]":
							showError(field, errorMsgs.purchaseLocation);
							break;
						case "contact[phone]":
							showError(field, errorMsgs.phone);
							break;
						case "contact[preferred_channel]":
							showError(field, errorMsgs.preferredChannel);
							break;
						default:
							showError(field, errorMsgs.default || errorMsgs.demande);
					}
			}
			return false;
		}
		removeError(field);
		return true;
	}

	// Validate email and confirm email fields match
	function validateEmailsMatch() {
		const email = mainFields.email.value.trim();
		const confirm = mainFields.confirmEmail.value.trim();
		let valid = true;

		// Prioritize format validation
		const emailPattern = /^[^@]+@[^@]+\.[^@]+$/;
		let emailValid = true;
		let confirmValid = true;

		if (!email) {
			showError(mainFields.email, errorMsgs.email);
			valid = false;
			emailValid = false;
		} else if (!emailPattern.test(email)) {
			showError(mainFields.email, errorMsgs.emailFormat || "Format d'email invalide");
			valid = false;
			emailValid = false;
		}

		if (!confirm) {
			showError(mainFields.confirmEmail, errorMsgs.confirmEmail);
			valid = false;
			confirmValid = false;
		} else if (!emailPattern.test(confirm)) {
			showError(mainFields.confirmEmail, errorMsgs.emailFormat || "Format d'email invalide");
			valid = false;
			confirmValid = false;
		}

		// Only check match if both are valid and only if submitAttempted
		if (emailValid && confirmValid) {
			if (email !== confirm) {
				if (submitAttempted) {
					showError(mainFields.email, errorMsgs.emailMatch);
					showError(mainFields.confirmEmail, errorMsgs.emailMatch);
				} else {
					removeError(mainFields.email);
					removeError(mainFields.confirmEmail);
				}
				valid = false;
			} else {
				removeError(mainFields.email);
				removeError(mainFields.confirmEmail);
			}
		}

		return valid;
	}

	// Track if submit has been attempted
	let submitAttempted = false;

	// Attach validation events to main fields and custom request textarea
	Object.values(mainFields).forEach((field) => {
		if (!field) return;
		field.addEventListener("input", () => {
			if (submitAttempted) {
				validateField(field);
				if (field === mainFields.email || field === mainFields.confirmEmail) validateEmailsMatch();
			} else {
				// Always remove error on input if not submitting, never show error
				removeError(field);
			}
		});
	});
	if (customRequestTextarea) {
		customRequestTextarea.addEventListener("input", () => {
			if (submitAttempted) {
				validateField(customRequestTextarea);
			} else {
				removeError(customRequestTextarea);
			}
		});
	}

	// Toggle which message fields are shown based on subject selection
	const subjectSelect = form.querySelector("#ContactForm-objet");

	// Enable/disable all fields in a wrapper
	function setDisabled(wrapper, disabled) {
		if (!wrapper) return;
		wrapper.querySelectorAll("input, select, textarea").forEach((el) => (el.disabled = disabled));
	}

	// Show/hide and enable/disable fields based on subject
	function toggleMessageFields() {
		const v = subjectSelect.value;
		// Remove all error messages when changing subject/object
		form.querySelectorAll("input, textarea, select").forEach(removeError);
		[messageWrapper, retourWrapper, repairWrapper, orderTrackingWrapper, withdrawWrapper, customRequestWrapper].forEach((w) => {
			if (w) w.style.display = "none";
		});
		[withdrawAdditionalMessage].forEach((w) => {
			if (w) w.style.display = "none";
		});
		setDisabled(messageWrapper, true);
		setDisabled(retourWrapper, true);
		setDisabled(repairWrapper, true);
		setDisabled(orderTrackingWrapper, true);
		setDisabled(withdrawWrapper, true);
		setDisabled(customRequestWrapper, true);

		if (v === "return") {
			retourWrapper.style.display = "";
			setDisabled(retourWrapper, false);
		} else if (v === "repair") {
			repairWrapper.style.display = "";
			setDisabled(repairWrapper, false);
		} else if (v === "order_tracking") {
			orderTrackingWrapper.style.display = "";
			setDisabled(orderTrackingWrapper, false);
		} else if (v === "withdraw") {
			withdrawWrapper.style.display = "";
			withdrawAdditionalMessage.style.display = "";
			setDisabled(withdrawWrapper, false);
		} else if (v === "custom_request") {
			customRequestWrapper.style.display = "";
			setDisabled(customRequestWrapper, false);
		} else if (["professional", "press", "general", "other"].includes(v)) {
			messageWrapper.style.display = "";
			setDisabled(messageWrapper, false);
		}

		// Update the shadow form when subject changes
		hideShadowForm();
	}
	toggleMessageFields();
	subjectSelect.addEventListener("change", toggleMessageFields);

	// Pre-fill the form from URL params
	// Client informations can already be defaulted from liquid, if specified they will be overridden
	function prefillFromContext() {
		const urlParams = new URLSearchParams(window.location.search);

		// Identity overrides (only when a non-empty param is provided)
		const firstNameParam = urlParams.get("first_name");
		const lastNameParam = urlParams.get("last_name");
		const emailParam = urlParams.get("email");
		if (firstNameParam && mainFields.firstName) mainFields.firstName.value = firstNameParam;
		if (lastNameParam && mainFields.lastName) mainFields.lastName.value = lastNameParam;
		if (emailParam && mainFields.email) mainFields.email.value = emailParam;
		if (emailParam && mainFields.email && mainFields.confirmEmail) mainFields.confirmEmail.value = emailParam;

		// Subject: select it and trigger toggleMessageFields() so the matching
		// wrapper is shown AND enabled before we fill its fields below.
		const subjectParam = urlParams.get("subject");
		if (subjectParam && [...subjectSelect.options].some((opt) => opt.value === subjectParam)) {
			subjectSelect.value = subjectParam;
			subjectSelect.dispatchEvent(new Event("change", { bubbles: true }));
		}

		// Subject-specific order/command number + comment fields
		const SUBJECT_PREFILL_MAP = {
			withdraw: { number: "contact[withdraw_number]", comment: "contact[withdraw_comment]" },
			order_tracking: { number: "contact[order_tracking_number]", comment: "contact[order_tracking_comment]" },
			return: { number: "contact[order_number]", comment: null },
		};
		const mapping = SUBJECT_PREFILL_MAP[subjectSelect.value];
		if (mapping) {
			const orderParam = urlParams.get("order");
			const commentParam = urlParams.get("comment");
			if (orderParam && mapping.number) {
				const numberField = form.querySelector(`[name="${mapping.number}"]`);
				if (numberField) numberField.value = orderParam;
			}
			if (commentParam && mapping.comment) {
				const commentField = form.querySelector(`[name="${mapping.comment}"]`);
				if (commentField) commentField.value = commentParam;
			}
		}
	}
	prefillFromContext();

	// Hide the shadow form in the Shadow DOM (for embedded apps)
	function hideShadowForm() {
		document
			.querySelectorAll('.section-app:has(div[data-forms-id^="forms-root-"]), div[data-forms-id^="forms-root-"]')
			.forEach((el) => (el.style.display = "none"));
	}
	hideShadowForm();

	// On submit: validate, inject values into shadow form, and submit it
	const submitBtn = form.querySelector(".js-contact-submit");
	if (submitBtn) {
		submitBtn.addEventListener("click", function (e) {
			e.preventDefault();
			submitAttempted = true;
			let valid = true;
			// Only validate required, visible, and enabled fields
			form.querySelectorAll("input[required], textarea[required], select[required]").forEach((field) => {
				if (!validateField(field)) valid = false;
			});
			// Validate custom request textarea if visible and required
			if (customRequestTextarea && customRequestWrapper && customRequestWrapper.style.display !== "none" && customRequestTextarea.required) {
				if (!validateField(customRequestTextarea)) valid = false;
			}
			if (!validateEmailsMatch()) valid = false;
			if (!valid) return;

			// Prepare delimited string for shadow content field
			const SEPARATOR = "|||";
			const fieldNodes = form.querySelectorAll("input, textarea, select");
			let contentArr = [];
			let emailValue = "";
			// Get the data-lang attribute from the form wrapper
			const langValue = document.querySelector(".contact-form__wrapper")?.getAttribute("data-lang") || "";
			// Add language as a field in the content array
			if (langValue) {
				contentArr.push("lang: " + langValue);
			}
			fieldNodes.forEach((node) => {
				if (node.type === "file" || !node.name || node.offsetParent === null) return;
				if (node.name === "contact[email]") {
					emailValue = node.value;
					return;
				}
				if (node.name === "confirm_email") return;
				let label = "";
				// const labelEl = form.querySelector('label[for="' + node.id + '"]');
				// label = labelEl ? labelEl.innerText.trim() : node.name.replace(/^contact\[|\]$/g, "").replace(/_/g, " ");
				// label = label.replace("(" + errorMsgs.optional + ")", "");
				label = node.name.replace(/^contact\[|\]$/g, "");
				let value =
					node.type === "checkbox" || node.type === "radio"
						? node.checked
							? node.value
							: ""
						: node.tagName.toLowerCase() === "select" && !node.multiple
							? node.options[node.selectedIndex]?.text || ""
							: node.tagName.toLowerCase() === "select" && node.multiple
								? Array.from(node.selectedOptions)
										.map((opt) => opt.text)
										.join(", ")
								: node.value;
				if (value) contentArr.push(label + ": " + value);
			});

			// Get the current shadow form ID based on the selected subject
			const currentShadowFormId = getShadowFormId();

			// Find the correct shadow form container in the main DOM
			const shadowFormContainer = document.querySelector(`div[data-forms-id="forms-root-${currentShadowFormId}"]`);
			if (!shadowFormContainer) {
				return;
			}

			// Find the form-embed inside the container
			const appEmbed = getFormEmbed(shadowFormContainer);
			if (!appEmbed) {
				return;
			}

			// Get the shadow root from form-embed
			const root = appEmbed.shadowRoot;
			if (!root) {
				return;
			}

			// Inject values into shadow form (for embedded apps)
			const shadowEmail = root.querySelector("#email");
			if (shadowEmail && emailValue) {
				shadowEmail.value = emailValue;
				shadowEmail.dispatchEvent(new Event("input", { bubbles: true }));
			}

			// Fallback is used to retrieve the previous field, can be removed once the new field is in production
			const shadowContent = root.querySelector('[name="custom#content_v2"]') ?? root.querySelector("#custom\\#content");
			if (shadowContent) {
				shadowContent.value = contentArr.join(SEPARATOR);
				shadowContent.dispatchEvent(new Event("input", { bubbles: true }));
			}

			// Only inject object/subject for general contact form
			const subjectSelect = form.querySelector("#ContactForm-objet");
			const shadowObject = root.querySelector("#custom\\#object");
			const subject = subjectSelect?.value;
			if (shadowObject && subject && !["custom_request", "professional", "repair"].includes(subject)) {
				shadowObject.value = subject;
				shadowObject.dispatchEvent(new Event("input", { bubbles: true }));
			}

			// Find the visible and enabled file input (either reparation or custom request)
			const fileInputs = [document.getElementById("file-upload"), document.getElementById("custom-request-file-upload")];
			const activeFileInput = fileInputs.find((el) => el && !el.disabled);

			// Inject up to 3 files from the active file input into the 3 shadow file fields
			if (activeFileInput) {
				const shadowFiles = [
					root.querySelector("#custom\\#file-field"),
					root.querySelector("#custom\\#file2-field"),
					root.querySelector("#custom\\#file3-field"),
				];
				const files = activeFileInput.files ? Array.from(activeFileInput.files) : [];
				for (let i = 0; i < 3; i++) {
					if (shadowFiles[i]) {
						if (files[i]) {
							const dt = new DataTransfer();
							dt.items.add(files[i]);
							shadowFiles[i].files = dt.files;
							shadowFiles[i].dispatchEvent(new Event("change", { bubbles: true }));
						} else {
							shadowFiles[i].value = "";
						}
					}
				}
			}

			const shadowForm = root.querySelector("form");
			if (shadowForm) {
				shadowForm.requestSubmit ? shadowForm.requestSubmit() : shadowForm.submit();
			}

			// After successful submit, reload with ?contact_posted=1 to show success message
			setTimeout(function () {
				const url = new URL(window.location.href);
				url.searchParams.set("contact_posted", true);
				window.location.href = url.toString();
			}, 3000); // delay to allow shadow form to submit
		});
	}

	// On page load, show success message if param is present
	const params = new URLSearchParams(window.location.search);
	if (params.get("contact_posted") == "true") {
		const formStatus = document.querySelector(".form-status-list");
		if (formStatus) {
			formStatus.style.display = "block";
			formStatus.scrollIntoView({ behavior: "smooth", block: "center" });
		}

		Shopify.analytics.publish("custom_contact_send", {
			event: "select_content",
			event_category: "contact",
			event_action: "success",
			event_label: "motif_contact",
		});
	} else if (params.get("contact_posted") == "false") {
		Shopify.analytics.publish("custom_contact_send", {
			event: "select_content",
			event_category: "contact",
			event_action: "fail",
			event_label: "motif_contact",
		});
	}
});
